export default {
  buttons: {
    cancel: "ANNULER",
    dismiss: "Fermer",
    add_waypoint: "Ajouter une destination"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Chercher ",
    placeholder: "Entrer un lieu",
    enter_location: "Entrer un lieu",
    help: {
      inactive: "Chercher "
    }
  },
  filters: {
    title: "Filtres",
    amenities: {
      title: "Services et commodités"
    },
    fuels: {
      title: "Types de carburants"
    }
  },
  directions: {
    title: "Planificateur d'itinéraire",
    placeholder: {
      destination: "Entrer un lieu",
      waypoint: "Entrer un lieu"
    },
    route: {
      title: "Options d'itinéraire",
      avoid_tolls: "Éviter les routes à péage",
      avoid_highways: "Éviter les autoroutes",
      title_corridor: "Distance jusqu'à la station la plus proche"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# jour} other {# jours}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Chercher "
  },
  locations: {
    title: "Sites",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} de {place}"
  },
  info_window: {
    title: "Détails station",
    services: "Services et commodités",
    nearby: "Près",
    mobile: {
      telephone: "Tel :"
    },
    opening_hours: {
      title: "Heures d'ouverture",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Dernière mise à jour",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Planificateur d'itinéraire"
  },
  fuels: {
    low_octane_gasoline: "Bronze",
    midgrade_gasoline: "Argent",
    premium_diesel: "Shell V-Power Diesel ",
    premium_gasoline: "Essence super Shell V-Power NiTro+",
    shell_regular_diesel: "Diesel à teneur ultra-faible en soufre"
  },
  amenities: {
    atm: "GA",
    austrian_highway_sticker: "Vignette d'autoroute - Autriche",
    bottled_gas: "Échange de bouteilles de propane",
    cafe: "Cafétéria",
    carwash: "Lave-auto ",
    clubsmart_card: "Carte à puce - Club",
    credit_card_american_express: "Carte de crédit - American Express",
    credit_card_diners_club: "Carte de crédit -  Diners Club",
    credit_card_mastercard: "Carte de crédit - Mastercard",
    credit_card_visa: "Carte de crédit - Visa",
    credit_card: "Carte de crédit",
    czech_highway_sticker: "Vignette d'autoroute - Rép. tchèque",
    deli_cafe: "delicafé by Shell",
    euroshell_card: "Carte Shell",
    fleet_card_dkv: "Carte DKV",
    fleet_card_eni: "Carte Eni",
    fleet_card_esso: "Carte Esso",
    fleet_card_general: "Carte pour parc",
    fleet_card_uta: "Carte UTA",
    food_offerings: "Services alimentaires",
    full_service: "Service avec personnel",
    guarded_car_park: "Stationnement avec gardien ",
    hgv_lane: "Accessible aux camions ",
    high_speed_diesel_pump: "Diesel à débit élevé",
    hot_food: "Mets chauds",
    hungarian_highway_sticker: "Vignette d'autoroute - Hongrie",
    maut_terminal: "Carte à puce - péage",
    parking_lanes: "Voie de stationnement",
    partner_loyalty_accepted: "Partenaire fidélité accepté",
    pay_at_pump: "Paiement à la pompe",
    quick_lubes: "Lubrification rapide ",
    self_service: "Libre-service",
    service_bay: "Baies de service",
    shell_card: "Carte Shell",
    shell_club_smart_extra_card: "Carte à puce OR - Club ",
    shop: "Dépanneur",
    shower: "Douche",
    slovak_highway_sticker: "Vignette d'autoroute - Slovaquie",
    snack_food: "Casse-croûte/restauration rapide",
    standard_toilet: "Toilettes",
    supermarket_fuel_discount: "Rabais sur carburant",
    toilet: "Toilettes",
    truck_parking: "Stationnement pour camions",
    truckport: "Camions seulement",
    twenty_four_hour: "24 heures",
    vacuum: "Aspirateur",
    vehicle_identity_system: "Système d'identification des véhicules",
    wifi: "Wi-Fi",
    adblue_truck: "AdBlue pour camions à la pompe",
    adblue_car: "AdBlue pour voitures à la pompe",
    adblue_pack: "Conteneur AdBlue dans le shop"
  },
  settings: {
    title: "Paramètres",
    tooltip: "Paramètres",
    distance_units: {
      km: "kilomètres",
      miles: "milles"
    },
    language: {
      title: "Langue"
    }
  }
}
